document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.swiper-prev',
            nextEl: '.swiper-next'
        },
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    let quadSlider = new Swiper('.slider__slider',{
        speed: 700,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        uniqueNavElements: false,
        pagination: {
            el: '.slider-pagination',
            clickable: true
        },
        autoplay: {
            delay: 7000,
            disableOnInteraction: false
        }
    });

    let quadSliderseasons = new Swiper('.slider-seasons__slider',{
        speed: 700,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        uniqueNavElements: false,
        pagination: {
            el: '.slider-seasons-pagination',
            clickable: true
        },
        autoplay: {
            delay: 7000,
            disableOnInteraction: false
        }
    });

    let swipercards = new Swiper('.cards__slider',{
        loop: true,
        speed: 700,
        slidesPerView: 1,
        spaceBetween: 0,
        // pagination: {
        //     el: '.cards-pagination',
        //     clickable: true
        // },
        navigation: {
            prevEl: '.cards-prev',
            nextEl: '.cards-next'
        },
        breakpoints: {
            760: {
                slidesPerView: 2,
                slidesPerGroup: 1
            },
            1025: {
                slidesPerView: 3,
                slidesPerGroup: 3
            }
        },
        // autoplay: {
        //     delay: 7000,
        //     disableOnInteraction: false
        // }
    });


    let swiperOffers = new Swiper('.all-offers__slider',{
        loop: true,
        speed: 700,
        slidesPerView: 1,
        spaceBetween: 40,
        navigation: {
            prevEl: '.all-offers-prev',
            nextEl: '.all-offers-next'
        },
        breakpoints: {
            760: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            1025: {
                slidesPerView: 3,
                spaceBetween: 40
            }
        },
        autoplay: {
            delay: 7000,
            disableOnInteraction: false
        }
    });

    let swiperEvents = new Swiper('.slider-events__slider',{
        loop: true,
        speed: 700,
        slidesPerView: 1,
        spaceBetween: 40,
        pagination: {
            el: '.slider-events-pagination',
            clickable: true
        },
        navigation: {
            prevEl: '.slider-events-prev',
            nextEl: '.slider-events-next'
        },
        breakpoints: {
            760: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            1025: {
                slidesPerView: 3,
                spaceBetween: 40
            }
        }
        // autoplay: {
        //     delay: 7000,
        //     disableOnInteraction: false
        // }
    });

    let swiperGalleryColumns = new Swiper('.gallery-columns__slider',{
        loop: true,
        speed: 1000,
        slidesPerView: 1.2,
        spaceBetween: 15,
        centeredSlides:true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
        breakpoints: {
            760: {
                spaceBetween: 20,
                slidesPerView: 3,
                centeredSlides: false
            },
            1025:{
                spaceBetween: 20,
                slidesPerView: 4,
                centeredSlides: false
            }
        },
        navigation: {
            prevEl: '.gallery-columns-prev',
            nextEl: '.gallery-columns-next'
        }
    });

    let swiperGallery = new Swiper('.gallery-quad__slider',{
        loop: true,
        speed: 1000,
        slidesPerView: 1.2,
        spaceBetween: 15,
        reverseDirection: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
        navigation: {
            prevEl: '.gallery-quad-prev',
            nextEl: '.gallery-quad-next'
        }
    });

    let sliderFilterMenu = new Swiper('.menus-quad__filter-slider', {
        loop: true,
        speed: 700,
        navigation: {
            prevEl: '.slider-menus-prev',
            nextEl: '.slider-menus-next'
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        }
    });

    let sliderMenus = new Swiper('.menus-quad__slider-menus',{
        loop: true,
        speed: 700,
        effect: 'fade',
        autoHeight: true, // Este podría funcionar en lugar de adaptiveHeight
        fadeEffect: {
            crossFade: true
        }
    })

    sliderFilterMenu.controller.control = sliderMenus;
    sliderMenus.controller.control = sliderFilterMenu;

    let sliderExperiences = new Swiper('.experiences__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: '.experiences-pagination',
            clickable: true
        },
    })
});